import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import fileDownload from 'js-file-download';
import { convertDate } from '../../../utils/utils';
import history from '../../../utils/history';
import { userCanEdit } from '../../../utils/permissionsOptions';

import SectionIcon from '../../icons/SectionIcon';
import FlagIcon from '../../icons/FlagIcon';
import AttachmentIcon from '../../icons/AttachmentIcon';
import InProgressIcon from '../../icons/InProgressIcon';
import * as assessmentsActions from '../../../redux/actions/assessmentsActions';

class RecentAssessmentItem extends Component {
  constructor(props) {
    super(props);
    this.tooltipRef = React.createRef();
  }

  renderPdf = () => {
    this.props.assessmentsActions.downloadAssessment(this.props.item.id, this.onSuccess);
  }

  onSuccess = (response) => {
    fileDownload(response, 'assessment.pdf', 'application/pdf');
  }

  onCardClick = (e) => {
    if (this.tooltipRef.current && this.tooltipRef.current.contains(e.target)) {
      // Ignore tooltip clicks
      return false;
    }
    if (!this.props.item.dateCompleted) {
      if (userCanEdit(this.props.currentUser)) {
        // Jump back into assessment
        history.push(`/assessments/${this.props.item.id}/${this.lastQuestionIndex}`);
      } else {
        // They aren't allowed to edit assessments, so do nothing
        return false;
      }
    } else if (this.props.item.uploaded) {
      // Download the uploaded print assessment
      this.renderPdf();
    } else {
      // It's a completed assessment
      history.push(`/review?assessments[]=${this.props.item.id}`);
    }
  }

  render() {
    const { item, section, currentUser, user } = this.props;
    if (!section) return null; // wait for sections before rendering

    this.lastQuestionIndex = item.lastQuestionIndex ? item.lastQuestionIndex + 1 : 1;
    return (
      <div className={'recent-assessments__card' + (!userCanEdit(currentUser) && !item.dateCompleted ? ' disabled' : '')} onClick={this.onCardClick}>
        <h3 className={`recent-assessments__subheading color--${section.theme}`}>{section.title}</h3>
        <div className="recent-assessments__meta">
          {item.dateCompleted
            ? 'Completed: ' + convertDate(item.dateCompleted)
            : (
              <Fragment>
                In Progress
                {' '}
                <InProgressIcon />
              </Fragment>
            )
          }
          <br />
          {user && (user.firstName + ' ' + user.lastName)}
        </div>
        {item.uploaded && (
          <div className="recent-assessments__attachment">
            <AttachmentIcon />
            {' '}
            PDF Upload
          </div>
        )}
        <div className="recent-assessments__false-link">
          {item.dateCompleted
            ? 'View Assessment'
            : (userCanEdit(currentUser)
              ? 'Continue Assessment'
              : null
            )
          }
        </div>
        <div className="recent-assessments__icon">
          <SectionIcon theme={section.theme} />
        </div>
        {!!item.flaggedQuestions && (
          <div className="recent-assessments__flag" tabIndex={0} ref={this.tooltipRef}>
            <FlagIcon />
            <div className="recent-assessments__tooltip">
              <div className="recent-assessments__tooltip-liner">
                {/*
                  <div className={"recent-assessments__tooltip-title color--" + section.theme}>
                    {section.title}
                  </div>
                */}
                <div className="recent-assessments__tooltip-questions">
                  {item.flaggedQuestions}
                  {' '}
                  Flagged Question
                  {item.flaggedQuestions === 1 ? '' : 's'}
                </div>
                {item.dateCompleted && (
                  <Link
                    to={{
                      pathname: '/review',
                      search: `?assessments[]=${item.id}`,
                      state: { showFlagged: true },
                    }}
                    className="flat-link"
                  >
                    View questions
                  </Link>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = undefined;

function mapDispatchToProps(dispatch) {
  return { assessmentsActions: bindActionCreators(assessmentsActions, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(RecentAssessmentItem);



// WEBPACK FOOTER //
// ./src/components/features/dashboard/RecentAssessmentItem.js